import { Component, booleanAttribute, computed, input } from '@angular/core';
import { cva } from 'class-variance-authority';
import { ClassValue } from 'class-variance-authority/types';

import { knx } from '@optical/ui/utils';

const pageContentVariants = cva(
  'max-w-8xl @container/page relative mx-auto flex w-full flex-1 flex-col',
  {
    variants: {
      padded: {
        true: 'p-4 md:p-6',
      },
    },
    defaultVariants: {
      padded: true,
    },
  },
);

@Component({
  selector: 'knx-page-content',
  host: { '[class]': '_computedClass()' },
  templateUrl: './page-content.component.html',
})
export class PageContentComponent {
  padded = input(true, { alias: 'knxPadded', transform: booleanAttribute });
  userClass = input<ClassValue>('', { alias: 'class' });

  protected readonly _computedClass = computed(() =>
    knx(pageContentVariants({ padded: this.padded() }), this.userClass()),
  );
}
